<template>
  <div class="demand-list-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-container">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i>首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>结算申请列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主内容卡片 -->
    <el-card class="main-card" shadow="hover">
      <!-- 查询条件区域 -->
      <div class="search-section">
        <div class="search-header">
          <div class="search-title">
            <i class="el-icon-search search-title-icon"></i>
            <span class="search-title-text">筛选查询</span>
          </div>
          <div class="toggle-section">
            <el-button
                    type="text"
                    @click="isCollapsed = !isCollapsed"
                    class="toggle-button"
            >
              <span>{{isCollapsed ? '展开' : '收起'}}</span>
              <i :class="collapseIcon" class="el-icon--right"></i>
            </el-button>
          </div>
        </div>

        <el-collapse-transition>
          <div v-show="!isCollapsed" class="search-content">
            <el-form
                    size="small"
                    :mo（del="searchForm"
                    :rules="searchRules"
                    ref="searchForRef"
                    label-width="100px"
                    autocomplete="on"
                    class="search-form"
            >
              <!-- 第一行搜索条件 -->
              <div class="search-row">
                <div class="search-item-group">
                  <el-form-item label="搜索名称" class="search-item">
                    <el-input
                            @input="goSearch"
                            v-model="searchForm.company_name"
                            placeholder="请输入执照名称"
                            clearable
                            type="text"
                            class="search-input"
                            prefix-icon="el-icon-search"
                    >
                      <template slot="prepend">
                        <span class="input-prepend">名称</span>
                      </template>
                    </el-input>
                  </el-form-item>
                </div>

                <div class="search-item-group">
                  <el-form-item label="状态筛选" class="search-item">
                    <el-select
                            @change="statusChange"
                            clearable
                            v-model="searchForm.status"
                            placeholder="全部状态"
                            class="status-select"
                    >
                      <el-option key="" label="全部状态" value=""></el-option>
                      <el-option key="1" label="正常" value="1">
                        <span class="status-option">
                          <i class="el-icon-success status-normal"></i>
                          正常
                        </span>
                      </el-option>
                      <el-option key="0" label="待审核" value="0">
                        <span class="status-option">
                          <i class="el-icon-time status-pending"></i>
                          待审核
                        </span>
                      </el-option>
                      <el-option key="2" label="驳回" value="2">
                        <span class="status-option">
                          <i class="el-icon-error status-rejected"></i>
                          驳回
                        </span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                </div>

                <div class="search-item-group">
                  <el-form-item label="类型筛选" class="search-item">
                    <el-select
                            clearable
                            v-model="searchForm.type"
                            placeholder="全部类型"
                            class="type-select"
                    >
                      <el-option key="" label="全部类型" value=""></el-option>
                      <el-option key="1" label="类型一" value="1"></el-option>
                      <el-option key="2" label="类型二" value="2"></el-option>
                      <el-option key="3" label="类型三" value="3"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
              </div>

              <!-- 第二行搜索条件 -->
              <div class="search-row">
                <div class="search-item-group full-width">
                  <el-form-item label="创建时间" class="search-item">
                    <div class="date-range-container">
                      <el-date-picker
                              @change="changeTime"
                              v-model="searchForm.start_end_date"
                              type="daterange"
                              align="right"
                              unlink-panels
                              range-separator="至"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期"
                              :picker-options="startEndOptions"
                              class="date-range-picker"
                      >
                        <template slot="prefix">
                          <i class="el-icon-date"></i>
                        </template>
                      </el-date-picker>
                      <div class="quick-date-buttons">
                        <el-button
                                size="mini"
                                @click="setQuickDate('today')"
                                :type="quickDate === 'today' ? 'primary' : ''"
                        >今天</el-button>
                        <el-button
                                size="mini"
                                @click="setQuickDate('week')"
                                :type="quickDate === 'week' ? 'primary' : ''"
                        >近一周</el-button>
                        <el-button
                                size="mini"
                                @click="setQuickDate('month')"
                                :type="quickDate === 'month' ? 'primary' : ''"
                        >近一月</el-button>
                        <el-button
                                size="mini"
                                @click="setQuickDate('quarter')"
                                :type="quickDate === 'quarter' ? 'primary' : ''"
                        >近三月</el-button>
                      </div>
                    </div>
                  </el-form-item>
                </div>
              </div>

              <!-- 操作按钮 -->
              <div class="search-actions">
                <el-button
                        @click="doSearch"
                        type="primary"
                        size="mini"
                        icon="el-icon-search"
                        class="search-btn"
                >查询</el-button>
                <el-button
                        @click="resetSearch"
                        icon="el-icon-refresh"
                        class="reset-btn"
                >重置</el-button>
                <el-button
                        size="mini"
                        type="text"
                        @click="toggleAdvancedSearch"
                        class="advanced-search-btn"
                >
                  <i class="el-icon-setting"></i>
                  {{ showAdvancedSearch ? '隐藏' : '显示' }}高级搜索
                </el-button>
              </div>

              <!-- 高级搜索区域 -->
              <el-collapse-transition>
                <div v-show="showAdvancedSearch" class="advanced-search-section">
                  <div class="advanced-search-title">
                    <i class="el-icon-coin"></i>
                    <span>高级搜索条件</span>
                  </div>
                  <div class="advanced-search-content">
                    <div class="search-row">
                      <div class="search-item-group">
                        <el-form-item label="支付状态" class="search-item">
                          <el-select
                                  clearable
                                  v-model="searchForm.pay_status"
                                  placeholder="全部状态"
                          >
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option key="1" label="已支付" value="1"></el-option>
                            <el-option key="0" label="未支付" value="0"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="search-item-group">
                        <el-form-item label="发票类型" class="search-item">
                          <el-select
                                  clearable
                                  v-model="searchForm.invoice_type"
                                  placeholder="全部类型"
                          >
                            <el-option key="" label="全部" value=""></el-option>
                            <el-option key="1" label="增值税发票" value="1"></el-option>
                            <el-option key="2" label="普通发票" value="2"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="search-item-group">
                        <el-form-item label="金额范围" class="search-item">
                          <el-input
                                  v-model="searchForm.min_amount"
                                  placeholder="最小金额"
                                  style="width: 100px"
                          ></el-input>
                          <span class="amount-separator">-</span>
                          <el-input
                                  v-model="searchForm.max_amount"
                                  placeholder="最大金额"
                                  style="width: 100px"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </div>
                </div>
              </el-collapse-transition>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>

      <!-- 操作按钮区域 -->
      <div class="action-section">
        <div class="action-title">
          <i class="el-icon-tickets"></i>
          <span>数据列表</span>
          <el-tag v-if="total > 0" type="info" size="small" class="total-tag">
            共 {{ total }} 条记录
          </el-tag>
        </div>
        <div class="action-buttons">
<!--          <el-button @click="goAdd" type="primary" icon="el-icon-plus" size="small" class="add-btn">-->
<!--            添加需求-->
<!--          </el-button>-->
          <el-button @click="goExcel" icon="el-icon-download" size="small" class="export-btn">
            导出数据
          </el-button>
          <el-dropdown @command="handleBatchCommand" class="batch-dropdown">
            <el-button size="small">
              批量操作<i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="batchDelete">批量删除</el-dropdown-item>
              <el-dropdown-item command="batchExport">批量导出</el-dropdown-item>
              <el-dropdown-item command="batchAudit">批量审核</el-dropdown-item>
              <el-dropdown-item command="batchDownloadInvoice" :disabled="multipleSelection.length === 0">
                批量下载发票
              </el-dropdown-item>
              <el-dropdown-item command="batchPayment" :disabled="multipleSelection.length === 0">
                批量打款
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>

      <!-- 表格区域 -->
      <div class="table-section">
        <el-table
                :data="tableLoadData"
                stripe
                size="small"
                border
                ref="multipleTable"
                @selection-change="handleSelectionChange"
                v-loading="loading"
                class="data-table"
                :header-cell-style="tableHeaderStyle"
        >
          <!-- 表格列定义保持不变 -->
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column label="结算金额" width="120" align="center">
            <template slot-scope="{row}">
              <span class="amount-text">¥{{row.amount || '0.00'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="来源" width="120" align="center">
            <template slot-scope="{row}">
              <span class="amount-text">{{row.type==1?"油税通":''}}</span>
              <span class="title-text">{{row.type==2?"第三方":''}}</span>
              <span >{{row.type==3?"反向通":''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="代理商编号" min-width="200" :show-overflow-tooltip='true'>
            <template slot-scope="{row}">
              <span class="title-text">{{row.proxy?row.proxy.sn:''}}</span>
              <div>{{row.proxy?row.proxy.real_name:''}}</div>
               <div>{{row.proxy?row.proxy.mobile:''}}</div>
            </template>
          </el-table-column>
          <el-table-column label="月份" min-width="100" :show-overflow-tooltip='true'>
            <template slot-scope="{row}">
              <span class="title-text">{{row.month}}</span>
            </template>
          </el-table-column>
          <!-- 发票展示列 -->
          <el-table-column label="发票" width="100" align="center">
            <template slot-scope="{row}">
              <div class="invoice-container">
                <el-tooltip v-if="row.file_url" effect="dark" :content="getInvoiceFileName(row.file_url)" placement="top">
                  <div class="invoice-preview" @click="previewInvoice(row)">
                    <i v-if="isPDF(row.file_url)" class="invoice-icon el-icon-document" style="color: #f56c6c;"></i>
                    <img v-else :src="row.file_url" class="invoice-thumbnail" alt="发票预览">
                  </div>
                </el-tooltip>
                <span v-else class="no-invoice">无发票</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="申请日期" width="160" align="center">
            <template slot-scope="{row}">
              <span class="time-text">{{row.add_time | timeFormat}}</span>
            </template>
          </el-table-column>
          <el-table-column label="审核状态" width="160" align="center">
            <template slot-scope="{row}">
              <div>
                <el-tag
                        :type="getAuthStatusType(row.is_auth)"
                        size="small"
                        effect="light"
                >
                  {{getAuthStatusText(row.is_auth)}}
                </el-tag>
              </div>
              <div v-if="row.is_auth==1" class="auth-time">
                <span class="time-text">{{row.time_auth|timeFormat}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="{row}">
              <el-tag
                      :type="getStatusType(row.status)"
                      size="small"
                      effect="light"
              >
                {{getStatusText(row.status)}}
              </el-tag>
            </template>
          </el-table-column>
<el-table-column label="备注" width="100" align="center">
            <template slot-scope="{row}">     
               {{row.audit_remark}}
            </template>
          </el-table-column>
          
          <el-table-column fixed="right" label="操作" width="280" align="center">
            <template slot-scope="scope">
              <div class="action-buttons-group">
                <el-button
                        v-if="scope.row.is_auth != 1"
                        type="primary"
                        size="mini"
                        @click="openAuditDialog(scope.row)"
                        icon="el-icon-edit"
                >审核</el-button>
                <el-button
                        v-if="scope.row.is_auth == 1"
                        type="success"
                        size="mini"
                        disabled
                        icon="el-icon-check"
                >已审核</el-button>
                <el-button
                        type="info"
                        size="mini"
                        @click="viewAuditDetail(scope.row)"
                        icon="el-icon-view"
                >详情</el-button>
                <el-button
                        type="danger"
                        size="mini"
                        @click="goDel(scope.row)"
                        icon="el-icon-delete"
                >删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination
                :current-page="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                background
        />
      </div>
    </el-card>

    <!-- 审核对话框 -->
    <el-dialog
            title="结算申请审核"
            :visible.sync="auditDialogVisible"
            width="800px"
            class="audit-dialog"
            :close-on-click-modal="false"
    >
      <el-form
              :model="auditForm"
              :rules="auditRules"
              ref="auditFormRef"
              label-width="180px"
              size="small"
      >
        <el-form-item label="申请信息" prop="info">
          <div class="audit-info">
            <div class="info-item">
              <span class="info-label">代理商：</span>
              <span class="info-value">{{auditForm.proxy?auditForm.proxy.sn:''}}&nbsp;&nbsp;{{auditForm.proxy?auditForm.proxy.real_name:''}}&nbsp;&nbsp;{{auditForm.proxy?auditForm.proxy.mobile:''}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">结算月份：</span>
              <span class="info-value">{{auditForm.month}}</span>
            </div>
            <div class="info-item">
              <span class="info-label">结算金额：</span>
              <span class="info-value amount">¥{{auditForm.amount || '0.00'}}<span style="color:#ff0000" v-if="auditForm.diff_amount != 0 && auditForm.diff_amount != ''">&nbsp;&nbsp;{{auditForm.diff_amount>=0?'+'+auditForm.diff_amount:auditForm.diff_amount}}&nbsp;&nbsp;=&nbsp;&nbsp;{{ real_amount }}</span></span>
            </div>
            <div class="info-item">
              <span class="info-label">申请时间：</span>
              <span class="info-value">{{auditForm.add_time | timeFormat}}</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="审核状态" prop="is_auth" required>
          <el-radio-group v-model="auditForm.is_auth" class="audit-status-group">
            <el-radio :label="1" class="audit-radio audit-pass">
<!--              <i class="el-icon-success"></i>-->
              审核通过
            </el-radio>
            <el-radio :label="2" class="audit-radio audit-reject">
<!--              <i class="el-icon-error"></i>-->
              审核驳回
            </el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
                label="提现修正金额(+-)"
        >
          <el-input
                  type="number"
                  v-model="auditForm.diff_amount"
                  placeholder="请输入提现金额修正+-"
          ></el-input>
        </el-form-item>
        <el-form-item
                label="付款商户"
                prop="pos_merchant_id" 
                required
        >
            <el-select
         v-model="auditForm.pos_merchant_id"
    filterable
    clearable
    placeholder="搜索付款商户号"
    style="width: 280px;"
    popper-class="shop-select-dropdown"
    :popper-append-to-body="false"
            >
              <el-option
                v-for="item in posMerchantList"
                :key="item.id"
                :label="item.merchant_name"
                :value="item.id"
                class="shop-option-item"
              >
                <div class="shop-option">
                  <div class="shop-name">{{ item.merchant_name }}</div>
                   <div class="shop-info">
                    <span>商户号：{{ item.merchant_no || '无' }}</span>
                  </div>
                </div>
              </el-option>
            </el-select>
       
        </el-form-item>
        <el-form-item
                label="审核备注"
                prop="audit_remark"
                :rules="[
            { required: auditForm.is_auth === 2, message: '驳回时必须填写备注', trigger: 'blur' },
            { min: 5, max: 200, message: '备注长度在 5 到 200 个字符', trigger: 'blur' }
          ]"
        >
          <el-input
                  type="textarea"
                  :rows="4"
                  v-model="auditForm.audit_remark"
                  placeholder="请输入审核备注信息，驳回时备注为必填项"
                  :maxlength="200"
                  show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item label="审核时间" prop="audit_time">
          <el-date-picker
                  v-model="auditForm.audit_time"
                  type="datetime"
                  placeholder="选择审核时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                  :default-time="new Date()"
          />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="auditDialogVisible = false" size="small">取消</el-button>
        <el-button
                type="primary"
                @click="submitAudit(8)"
                size="small"
                :loading="auditLoading"
        >自动付款</el-button>
        <el-button
                type="primary"
                @click="submitAudit(7)"
                size="small"
                :loading="auditLoading"
        >人工付款</el-button>
      </div>
    </el-dialog>

    <!-- 审核详情对话框 -->
    <el-dialog
            title="审核详情"
            :visible.sync="auditDetailDialogVisible"
            width="700px"
            class="audit-detail-dialog"
    >
      <div class="audit-detail">
        <div class="detail-section">
          <h4 class="detail-title">申请信息</h4>
          <div class="detail-content">
            <div class="detail-item">
              <span class="detail-label">代理商编号：</span>
              <span class="detail-value">{{currentAuditDetail.proxy?currentAuditDetail.proxy.sn:''}}</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">结算月份：</span>
              <span class="detail-value">{{currentAuditDetail.year}}年{{currentAuditDetail.month}}月</span>
            </div>
            <div class="detail-item">
              <span class="detail-label">结算金额：</span>
              <span class="detail-value amount">¥{{currentAuditDetail.amount || '0.00'}}</span>
            </div>
          </div>
        </div>

        <div class="detail-section">
          <h4 class="detail-title">审核信息</h4>
          <div class="detail-content">
            <div class="detail-item">
              <span class="detail-label">审核状态：</span>
              <el-tag
                      :type="getAuthStatusType(currentAuditDetail.is_auth)"
                      size="small"
              >
                {{getAuthStatusText(currentAuditDetail.is_auth)}}
              </el-tag>
            </div>
            <div class="detail-item">
              <span class="detail-label">审核时间：</span>
              <span class="detail-value">{{currentAuditDetail.time_auth | timeFormat}}</span>
            </div>
            <div class="detail-item" >
              <span class="detail-label">审核备注：</span>
              <span class="detail-value remark">{{currentAuditDetail.audit_remark}}</span>
            </div>
          </div>
        </div>
        <!--2-->

         <div class="detail-section">
            <h4 class="detail-title">付款记录</h4>
             <el-table
      :data="paymentList"
      style="width: 100%">
      <el-table-column
        prop="amount"
        label="付款金额"
        width="180">
      </el-table-column>
      <el-table-column
        label="付款日期"
        width="180">
        <template slot-scope="scope" >         
                {{scope.row.pay_time|timeFormat}}
            </template>
      </el-table-column>
      <el-table-column
        label="付款状态"
        width="180">
        <template  slot-scope="scope">         
                <span style="color:#67C23A" v-if="scope.row.pay_status==2">已付</span>
                 <el-button type="danger" v-if="scope.row.pay_status==0" size="mini">继续付款</el-button>
              
            </template>
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注">
      </el-table-column>
    </el-table>
          </div>
        <!--3-->
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="auditDetailDialogVisible = false" size="small">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 发票预览对话框 -->
    <el-dialog
            :visible.sync="invoicePreviewVisible"
            :title="invoicePreviewTitle"
            width="90%"
            top="5vh"
            class="invoice-preview-dialog"
            @close="closePreview"
    >
      <div class="invoice-preview-content">
        <div v-if="previewInvoiceType === 'pdf'" class="pdf-preview">
          <iframe
                  :src="currentInvoiceUrl"
                  width="100%"
                  height="600px"
                  frameborder="0"
          ></iframe>
          <div class="pdf-download">
            <el-button
                    type="primary"
                    icon="el-icon-download"
                    @click="downloadInvoice(currentInvoiceUrl)"
            >下载PDF</el-button>
          </div>
        </div>
        <div v-else class="image-preview">
          <el-image
                  :src="currentInvoiceUrl"
                  :preview-src-list="previewImageList"
                  fit="contain"
                  style="width: 100%; max-height: 70vh;"
                  :z-index="9999"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
              <div>图片加载失败</div>
            </div>
          </el-image>
          <div class="image-tools">
            <el-button
                    type="primary"
                    icon="el-icon-download"
                    @click="downloadInvoice(currentInvoiceUrl)"
                    size="small"
            >下载图片</el-button>
            <el-button
                    type="info"
                    icon="el-icon-full-screen"
                    @click="openFullScreen"
                    size="small"
            >全屏查看</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 全屏图片查看器 -->
    <el-dialog
            :visible.sync="fullScreenVisible"
            title="发票预览"
            width="100%"
            top="0"
            custom-class="full-screen-dialog"
            @close="fullScreenVisible = false"
    >
      <div class="full-screen-content">
        <el-image
                :src="currentInvoiceUrl"
                fit="contain"
                style="width: 100%; height: 100%;"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
            <div>图片加载失败</div>
          </div>
        </el-image>
      </div>
    </el-dialog>

    <!-- 批量打款对话框 -->
    <el-dialog
            title="批量打款"
            :visible.sync="batchPaymentDialogVisible"
            width="600px"
            class="batch-payment-dialog"
            :close-on-click-modal="false"
    >
      <el-form
              :model="batchPaymentForm"
              :rules="batchPaymentRules"
              ref="batchPaymentFormRef"
              label-width="100px"
              size="small"
      >
        <!-- 已选择记录信息 -->
        <el-form-item label="已选择">
          <div class="selected-items">
            <el-tag
                    v-for="(item, index) in multipleSelection"
                    :key="index"
                    type="info"
                    size="small"
                    closable
                    @close="removeSelectedItem(index)"
                    style="margin-right: 5px; margin-bottom: 5px;"
            >
              {{ item.proxy_sn }} - ¥{{ item.balance || '0.00' }}
            </el-tag>
            <div class="selected-count">
              共 {{ multipleSelection.length }} 条记录，总金额：¥{{ calculateTotalAmount() }}
            </div>
          </div>
        </el-form-item>

        <!-- 打款状态 -->
        <el-form-item label="打款状态" prop="status" required>
          <el-radio-group v-model="batchPaymentForm.status" class="payment-status-group">
            <el-radio :label="1" class="payment-radio payment-success">
<!--              <i class="el-icon-success"></i> -->
              打款成功
            </el-radio>
            <el-radio :label="2" class="payment-radio payment-failed">
<!--              <i class="el-icon-error"></i>-->
              打款失败
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- 打款日期 -->
        <el-form-item label="打款日期" prop="payment_date" required>
          <el-date-picker
                  v-model="batchPaymentForm.payment_date"
                  type="date"
                  placeholder="选择打款日期"
                  value-format="yyyy-MM-dd"
                  style="width: 100%"
          />
        </el-form-item>

        <!-- 打款时间 -->
        <el-form-item label="打款时间" prop="payment_time" required>
          <el-date-picker
                  v-model="batchPaymentForm.payment_time"
                  type="datetime"
                  placeholder="选择打款时间"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%"
                  :default-time="new Date()"
          />
        </el-form-item>

        <!-- 打款凭证 -->
        <el-form-item label="打款凭证" prop="payment_voucher">
          <el-upload
                  class="payment-voucher-upload"
                  action="/api/upload"
                  :on-success="handleVoucherSuccess"
                  :on-remove="handleVoucherRemove"
                  :before-upload="beforeVoucherUpload"
                  :file-list="batchPaymentFiles"
                  :limit="5"
                  :on-exceed="handleExceed"
                  list-type="picture"
                  accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
          >
            <el-button size="small" type="primary">上传凭证</el-button>
            <div slot="tip" class="el-upload__tip">
              支持上传图片、PDF、Word文档，单文件不超过10MB
            </div>
          </el-upload>
        </el-form-item>

        <!-- 备注 -->
        <el-form-item label="备注" prop="remark">
          <el-input
                  type="textarea"
                  :rows="3"
                  v-model="batchPaymentForm.remark"
                  placeholder="请输入打款备注信息"
                  :maxlength="500"
                  show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="batchPaymentDialogVisible = false" size="small">取消</el-button>
        <el-button
                type="primary"
                @click="submitBatchPayment"
                size="small"
                :loading="batchPaymentLoading"
        >确认打款</el-button>
      </div>
    </el-dialog>

    <!-- 批量下载进度对话框 -->
    <el-dialog
            title="批量下载发票"
            :visible.sync="downloadDialogVisible"
            width="400px"
            :close-on-click-modal="false"
            :show-close="false"
    >
      <div class="download-progress">
        <div class="progress-text">
          正在打包发票文件... ({{ downloadProgress }}%)
        </div>
        <el-progress
                :percentage="downloadProgress"
                :status="downloadProgress === 100 ? 'success' : ''"
                :stroke-width="12"
                style="margin: 20px 0;"
        />
        <div class="download-info">
          已选择 {{ downloadInvoiceList.length }} 个发票文件
          <span v-if="downloadProgress === 100" style="color: #67C23A; margin-left: 10px;">
        <i class="el-icon-success"></i> 打包完成
      </span>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
                v-if="downloadProgress === 100"
                type="primary"
                @click="downloadZipFile"
                size="small"
        >下载压缩包</el-button>
        <el-button
                v-if="downloadProgress < 100"
                @click="cancelDownload"
                size="small"
        >取消</el-button>
        <el-button
                v-if="downloadProgress === 100"
                @click="downloadDialogVisible = false"
                size="small"
        >关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import JSZip from 'jszip';
  import { saveAs } from 'file-saver';
  import moment from "moment";
  export default {
    name: "demandList",
    data() {
      return {
        paymentList:[],
        loading: false,
        isCollapsed: false, // 默认展开搜索条件
        showAdvancedSearch: false, // 高级搜索
        quickDate: '', // 快速日期选择
        posMerchantList:[],
        // 审核相关数据
        auditDialogVisible: false,
        auditDetailDialogVisible: false,
        auditLoading: false,
        auditForm: {
          id: '',
          proxy: '',
          year: '',
          month: '',
          balance: '',
          add_time: '',
          is_auth: 1, // 1-通过 2-驳回
          audit_remark: '',
          diff_amount:0,
          pos_merchant_id:'',
          audit_time: moment().format('YYYY-MM-DD HH:mm:ss')
        },
        currentAuditDetail: {},
        auditRules: {
          is_auth: [
            { required: true, message: '请选择审核状态', trigger: 'change' }
          ],
          audit_time: [
            { required: true, message: '请选择审核时间', trigger: 'change' }
          ],
          pos_merchant_id:[
             { required: true, message: '请选择付款商户', trigger: 'change' }
          ]
        },

        // 发票预览相关
        invoicePreviewVisible: false,
        fullScreenVisible: false,
        currentInvoiceUrl: '',
        previewInvoiceType: '',
        invoicePreviewTitle: '发票预览',
        previewImageList: [],

        startEndOptions:{
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        refundTypeList:[{id:1,name:'线下'},{id:2,name:'系统自动'}],
        addForm:{
          title:'',
          refund_amount:0,
          refund_type:'',
          refund_reason:'',
          add_time:'',
          company_name:'',
          type:'',
          deal_time:'',
          status:'',
          id:'',
          name:'',
          sex:'',
          mobile:'',
          relaction_id:'',
          birthday:''
        },
        relationList:[],
        rules: {
          name:[
            { required: true, message: "请输入学员姓名", trigger: 'change' }
          ],
          mobile:[
            { required: true, message: "请输入手机号", trigger: 'change' }
          ],
        },
        checkAll: false,
        isIndeterminate: false,
        multipleSelection: [],
        formData:{},
        visible:false,
        title: '',
        searchForm:{
          start_end_date:'',
          start_end_date1:'',
          type_id:'',
          start_time:'',
          end_time:'',
          status:'',
          sex:"",
          keyword:'',
          proxy_id:sessionStorage.getItem('proxy_id'),
          shop_id:sessionStorage.getItem('shop_id'),
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pay_status: '',
          invoice_type: '',
          min_amount: '',
          max_amount: '',
          type: ''
        },
        searchRules:{},
        currentPage:1,
        pageSize:10,
        tableLoadData:[],
        total:0,
        batchPaymentDialogVisible: false,
        batchPaymentLoading: false,
        batchPaymentForm: {
          payment_time: moment().format('YYYY-MM-DD HH:mm:ss'),
          payment_voucher: '',
          payment_date: moment().format('YYYY-MM-DD'),
          remark: '',
          status: 1 // 1-已打款 2-打款失败
        },
        batchPaymentRules: {
          payment_time: [
            { required: true, message: '请选择打款时间', trigger: 'change' }
          ],
          payment_date: [
            { required: true, message: '请选择打款日期', trigger: 'change' }
          ],
          status: [
            { required: true, message: '请选择打款状态', trigger: 'change' }
          ]
        },
        batchPaymentFiles: [],

        // 批量发票下载相关
        batchDownloadLoading: false,
        downloadInvoiceList: [],
        downloadProgress: 0,
        downloadDialogVisible: false
      }
    },

    computed: {
      collapseIcon() {
        return this.isCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
      },
      real_amount() {
      // 转为数字，避免字符串拼接
       const amount = Number(this.auditForm.amount || 0)
       const diff = Number(this.auditForm.diff_amount || 0)
       return (amount + diff).toFixed(2) // 保留2位小数
    }
    },

    created() {
      this.DataList();
      this.getDicList('eduRelation');
      this.getPosMemberList();
    },
    filters: {
      dateFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD ");
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    methods: {
      // 打开审核对话框
      openAuditDialog(row) {
        this.auditForm = {
          id: row.id,
          proxy: row.proxy,
          year: row.year,
          month: row.month,
          amount: row.amount,
          add_time: row.add_time,
          is_auth: 1,
          audit_remark: '',
          audit_time: moment().format('YYYY-MM-DD HH:mm:ss')
        };
        this.auditDialogVisible = true;
        // 清除表单验证
        this.$nextTick(() => {
          if (this.$refs.auditFormRef) {
            this.$refs.auditFormRef.clearValidate();
          }
        });
      },
      // 提交审核
      submitAudit(payment_id) {
        this.$refs.auditFormRef.validate((valid) => {
          if (valid) {
            this.auditLoading = true;
            const param = {
              id: this.auditForm.id,
              is_auth: this.auditForm.is_auth,
              audit_remark: this.auditForm.audit_remark,
              diff_amount:this.auditForm.diff_amount,
              audit_time: this.auditForm.audit_time,
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token'),
              payment_id:payment_id
            };

            // 这里调用实际的审核API
            this.$axios.auditProxyWithdraw(param).then(res => {
              if (res.code == 200) {
                this.$message.success('审核提交成功');
                this.auditDialogVisible = false;
                this.DataList(); // 刷新列表
              } else {
                this.$message.error(res.msg || '审核提交失败');
              }
            }).catch(error => {
              console.error('审核提交错误:', error);
              this.$message.error('审核提交失败');
            }).finally(() => {
              this.auditLoading = false;
            });
          }
        });
      },

      // 查看审核详情
      viewAuditDetail(row) {
         const param = {
          company_id:this.searchForm.company_id,
          access_token:this.searchForm.access_token,
          from_id:row.id,
          source_id: 1
        }
        console.log('999-----8888888')
        this.$axios.findHisPaymentList(param).then(res=>{
           if(res.code==200){
              this.paymentList=res.data;
           }
        });
        this.currentAuditDetail = { ...row };
        this.auditDetailDialogVisible = true;

      },

      // 获取审核状态类型
      getAuthStatusType(status) {
        const statusMap = {
          2: 'danger', // 已审核
          1: 'success', // 已审核
          0: 'warning'  // 待审核
        };
        return statusMap[status] || 'info';
      },

      // 获取审核状态文本
      getAuthStatusText(status) {
        const statusMap = {
          2: '拒绝',
          1: '已审核',
          0: '待审核'
        };
        return statusMap[status] || '未知';
      },

      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.currentPage = 1;
        this.DataList()
      },

      // 分页跳转
      handleCurrentChange(newPage) {
        this.currentPage = newPage
        this.DataList()
      },

      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.checkAll = this.multipleSelection.length === this.studentList.length;
        this.isIndeterminate = this.multipleSelection.length > 0 && !this.checkAll;
      },

      doSearch(){
        this.currentPage=1;
        this.tableLoadData=[];
        this.total=0;
        this.DataList();
      },

      DataList(){
        let _this=this;
        const param = {
          company_id:_this.searchForm.company_id,
          access_token:_this.searchForm.access_token,
          proxy_id:_this.searchForm.proxy_id,
          pageNum: this.currentPage,
          pageSize: this.pageSize,

        }

        if(this.searchForm.start_end_date){
          const [start_date,end_date]=this.searchForm.start_end_date;
          param.start_time=start_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+start_date.getDate();
          param.end_time=end_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+end_date.getDate();
        }
        if(this.searchForm.start_end_date1){
          const [start_date,end_date]=this.searchForm.start_end_date1;
          param.pay_start_time=start_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+start_date.getDate();
          param.pay_end_time=end_date.getFullYear()+'-'+(start_date.getMonth()+1)+"-"+end_date.getDate();
        }
        if(!isNaN(this.searchForm.status)){
          param.status=this.searchForm.status;
        }
        if(!isNaN(this.searchForm.pay_status)){
          param.pay_status=this.searchForm.pay_status;
        }
        if(!isNaN(this.searchForm.type)){
          param.type=this.searchForm.type;
        }
        if(this.searchForm.company_name){
          param.company_name=this.searchForm.company_name;
        }
        param.order='add_time desc';

        this.$axios.findProxyBalanceWithdrawListP(param).then(res=>{
          if(res.code == 200){
            this.tableLoadData = res.data.data;
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      // 设置快速日期
      setQuickDate(type) {
        this.quickDate = type;
        const end = new Date();
        const start = new Date();

        switch(type) {
          case 'today':
            start.setTime(start.getTime());
            break;
          case 'week':
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            break;
          case 'month':
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            break;
          case 'quarter':
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            break;
        }

        this.searchForm.start_end_date = [start, end];
        this.changeTime();
      },

      // 切换高级搜索
      toggleAdvancedSearch() {
        this.showAdvancedSearch = !this.showAdvancedSearch;
      },

      // 表格头部样式
      tableHeaderStyle() {
        return {
          backgroundColor: '#f5f7fa',
          color: '#606266',
          fontWeight: '600',
          fontSize: '14px'
        }
      },


      batchDelete() {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择要删除的记录');
          return;
        }
        this.$confirm(`确定要删除选中的 ${this.multipleSelection.length} 条记录吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 执行批量删除逻辑
          this.$message.success('批量删除成功');
        });
      },

      batchExport() {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择要导出的记录');
          return;
        }
        // 执行批量导出逻辑
        this.$message.success('批量导出成功');
      },

      batchAudit() {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择要审核的记录');
          return;
        }
        // 执行批量审核逻辑
        this.$message.success('批量审核成功');
      },

      // 重置搜索
      resetSearch() {
        this.searchForm = {
          start_end_date: '',
          start_end_date1: '',
          type_id: '',
          start_time: '',
          end_time: '',
          status: '',
          sex: "",
          keyword: '',
          proxy_id: sessionStorage.getItem('proxy_id'),
          shop_id: sessionStorage.getItem('shop_id'),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          pay_status: '',
          invoice_type: '',
          min_amount: '',
          max_amount: '',
          type: '',
          company_name: ''
        };
        this.quickDate = '';
        this.doSearch();
      },

      // 发票相关方法
      isPDF(url) {
        return url && url.toLowerCase().endsWith('.pdf');
      },

      getInvoiceFileName(url) {
        if (!url) return '';
        return url.substring(url.lastIndexOf('/') + 1);
      },

      previewInvoice(row) {
        if (!row.file_url) {
          this.$message.warning('暂无发票信息');
          return;
        }

        this.currentInvoiceUrl = row.file_url;
        this.previewInvoiceType = this.isPDF(row.file_url) ? 'pdf' : 'image';
        this.invoicePreviewTitle = `发票预览 - ${this.getInvoiceFileName(row.file_url)}`;

        if (this.previewInvoiceType === 'image') {
          this.previewImageList = [row.file_url];
        }

        this.invoicePreviewVisible = true;
      },

      closePreview() {
        this.currentInvoiceUrl = '';
        this.previewImageList = [];
      },

      openFullScreen() {
        this.fullScreenVisible = true;
      },

      downloadInvoice(url) {
        const link = document.createElement('a');
        link.href = url;
        link.download = this.getInvoiceFileName(url);
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },

      getStatusType(status) {
        const statusMap = {
          0: 'warning',
          1: 'success',
          2: 'danger'
        };
        return statusMap[status] || 'info';
      },

      getStatusText(status) {
        const statusMap = {
          0: '待审核',
          1: '正常',
          2: '驳回'
        };
        return statusMap[status] || '未知';
      },

      goAdd(){
        // 添加逻辑
      },

      goExcel(){
        // 导出逻辑
      },

      // ... 其他方法保持不变
      statusChange(){
        this.goSearch();
      },

      changeTime(){
        this.goSearch();
      },

      changeTime1(){
        this.goSearch();
      },

      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },

      goEdit(row,index){
        console.log(row,index)
        // 原有编辑逻辑
      },

      goSearch(){
        this.currentPage=1;
        this.tableLoadData=[];
        this.total=0;
        this.DataList();
      },

      getDicList(code){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:code,
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            if(code=='eduRelation'){
              this.relationList =res.data;
            }
          }
        }).catch(error=>{
          console.log(error);
        })
      },

      getPosMemberList(){
         const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token')
        }
        this.$axios.findPosMemberList(param).then(res=>{
          if(res.code == 200){
              this.posMerchantList =res.data;
          }
        });

      },
      goDel(item) {
        this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            id:item.id,
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }
          this.$axios.demandDel(param).then(res=>{
            if(res.code == 200){
              this.$message.success(res.msg);
              this.total=0;
              this.tableLoadData=[];
              this.currentPage=1;
              this.DataList()
            }else{
              this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          });
        });
      },
      // 处理批量操作命令
      handleBatchCommand(command) {
        switch(command) {
          case 'batchDelete':
            this.batchDelete();
            break;
          case 'batchExport':
            this.batchExport();
            break;
          case 'batchAudit':
            this.batchAudit();
            break;
          case 'batchDownloadInvoice':
            this.batchDownloadInvoice();
            break;
          case 'batchPayment':
            this.openBatchPaymentDialog();
            break;
        }
      },

      // 打开批量打款对话框
      openBatchPaymentDialog() {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择要打款的记录');
          return;
        }

        // 重置表单
        this.batchPaymentForm = {
          payment_time: moment().format('YYYY-MM-DD HH:mm:ss'),
          payment_voucher: '',
          payment_date: moment().format('YYYY-MM-DD'),
          remark: '',
          status: 1
        };
        this.batchPaymentFiles = [];
        this.batchPaymentDialogVisible = true;

        this.$nextTick(() => {
          if (this.$refs.batchPaymentFormRef) {
            this.$refs.batchPaymentFormRef.clearValidate();
          }
        });
      },

      // 计算总金额
      calculateTotalAmount() {
        return this.multipleSelection.reduce((total, item) => {
          return total + (parseFloat(item.balance) || 0);
        }, 0).toFixed(2);
      },

      // 移除选中的项目
      removeSelectedItem(index) {
        this.multipleSelection.splice(index, 1);
        this.$refs.multipleTable.clearSelection();
        this.multipleSelection.forEach(item => {
          this.toggleRowSelection(item, true);
        });
      },

      // 上传凭证成功处理
      handleVoucherSuccess(response, file, fileList) {
        this.batchPaymentFiles = fileList;
        if (response && response.data) {
          this.batchPaymentForm.payment_voucher = response.data.url;
        }
      },

      // 移除凭证
      handleVoucherRemove(file, fileList) {
        this.batchPaymentFiles = fileList;
        this.batchPaymentForm.payment_voucher = '';
      },

      // 上传前验证
      beforeVoucherUpload(file) {
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          this.$message.error('上传文件大小不能超过 10MB!');
          return false;
        }
        return true;
      },

      // 超出文件限制
      handleExceed(files, fileList) {
        console.log(files,fileList)
        this.$message.warning(`最多只能上传 5 个文件`);
      },

      // 提交批量打款
      submitBatchPayment() {
        this.$refs.batchPaymentFormRef.validate((valid) => {
          if (valid) {
            // 验证是否有可打款的记录
            const validRecords = this.multipleSelection.filter(item => {
              // 只有已审核且状态正常的记录才能打款
              return item.is_auth === 1 && item.status === 1;
            });

            if (validRecords.length === 0) {
              this.$message.warning('选中的记录中没有可打款的记录（需要已审核且状态正常）');
              return;
            }

            this.batchPaymentLoading = true;

            const param = {
              ids: validRecords.map(item => item.id),
              payment_time: this.batchPaymentForm.payment_time,
              payment_date: this.batchPaymentForm.payment_date,
              payment_voucher: this.batchPaymentForm.payment_voucher,
              remark: this.batchPaymentForm.remark,
              status: this.batchPaymentForm.status,
              total_amount: this.calculateTotalAmount(),
              company_id: sessionStorage.getItem('company_id'),
              access_token: sessionStorage.getItem('token')
            };

            // 调用批量打款API
            this.$axios.batchPayment(param).then(res => {
              if (res.code == 200) {
                this.$message.success('批量打款成功');
                this.batchPaymentDialogVisible = false;
                this.DataList(); // 刷新列表

                // 记录操作日志
                this.logBatchPayment(validRecords, param);
              } else {
                this.$message.error(res.msg || '批量打款失败');
              }
            }).catch(error => {
              console.error('批量打款错误:', error);
              this.$message.error('批量打款失败');
            }).finally(() => {
              this.batchPaymentLoading = false;
            });
          }
        });
      },

      // 记录批量打款日志
      logBatchPayment(records, params) {
        const logData = {
          action: 'batch_payment',
          records_count: records.length,
          total_amount: params.total_amount,
          payment_time: params.payment_time,
          operator: sessionStorage.getItem('user_name') || '未知用户',
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token')
        };

        // 调用日志记录API
        this.$axios.logAction(logData).catch(error => {
          console.error('记录日志失败:', error);
        });
      },

      // 批量下载发票
      // async batchDownloadInvoice() {
      //   if (this.multipleSelection.length === 0) {
      //     this.$message.warning('请选择要下载发票的记录');
      //     return;
      //   }
      //
      //   // 筛选有发票的记录
      //   this.downloadInvoiceList = this.multipleSelection.filter(item => item.file_url);
      //
      //   if (this.downloadInvoiceList.length === 0) {
      //     this.$message.warning('选中的记录中没有发票文件');
      //     return;
      //   }
      //
      //   this.downloadProgress = 0;
      //   this.downloadDialogVisible = true;
      //
      //   try {
      //     // 模拟打包过程
      //     await this.simulateZipProcess();
      //
      //     // 实际项目中应该调用后端API打包文件
      //     // await this.downloadInvoicesFromServer();
      //
      //   } catch (error) {
      //     console.error('打包失败:', error);
      //     this.$message.error('发票打包失败');
      //     this.downloadDialogVisible = false;
      //   }
      // },

      // 模拟打包过程
      simulateZipProcess() {
        return new Promise((resolve) => {
          const interval = setInterval(() => {
            this.downloadProgress += 10;
            if (this.downloadProgress >= 100) {
              clearInterval(interval);
              resolve();
            }
          }, 200);
        });
      },

      // 下载压缩包
      // downloadZipFile() {
      //   // 实际项目中应该从服务器下载压缩包
      //   // const downloadUrl = '/api/download/invoices';
      //   // window.open(downloadUrl);
      //
      //   // 这里模拟下载
      //   const blob = new Blob(['模拟发票压缩包内容'], { type: 'application/zip' });
      //   const url = window.URL.createObjectURL(blob);
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.download = `invoice_batch_${moment().format('YYYYMMDDHHmmss')}.zip`;
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      //   window.URL.revokeObjectURL(url);
      //
      //   this.downloadDialogVisible = false;
      //   this.$message.success('发票下载成功');
      // },



      // 实际从服务器下载发票的方法
      async downloadInvoicesFromServer() {
        const param = {
          ids: this.downloadInvoiceList.map(item => item.id),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token')
        };

        try {
          const response = await this.$axios.downloadInvoices(param);

          if (response.data) {
            // 创建下载链接
            const blob = new Blob([response.data], { type: 'application/zip' });
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `invoices_${moment().format('YYYYMMDDHHmmss')}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);

            this.downloadDialogVisible = false;
            this.$message.success('发票下载成功');
          }
        } catch (error) {
          console.error('下载发票失败:', error);
          throw error;
        }
      },

      // 表格行选中切换
      toggleRowSelection(row, selected) {
        this.$refs.multipleTable.toggleRowSelection(row, selected);
      },


      // 批量下载发票（真实打包下载）
      async batchDownloadInvoice() {
        if (this.multipleSelection.length === 0) {
          this.$message.warning('请选择要下载发票的记录');
          return;
        }

        // 筛选有发票的记录
        const invoiceRecords = this.multipleSelection.filter(item => item.file_url);

        if (invoiceRecords.length === 0) {
          this.$message.warning('选中的记录中没有发票文件');
          return;
        }

        // 检查文件数量和大小
        if (invoiceRecords.length > 50) {
          this.$confirm(`您选择了 ${invoiceRecords.length} 个文件，数量较多可能会影响下载速度，是否继续？`, '提示', {
            confirmButtonText: '继续下载',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.startDownloadProcess(invoiceRecords);
          });
        } else {
          this.startDownloadProcess(invoiceRecords);
        }
      },

// 开始下载流程
      async startDownloadProcess(invoiceRecords) {
        this.downloadInvoiceList = invoiceRecords;
        this.downloadProgress = 0;
        this.downloadDialogVisible = true;

        try {
          // 创建ZIP文件
          const zip = new JSZip();
          const totalFiles = invoiceRecords.length;
          let processedFiles = 0;

          // 下载每个文件并添加到ZIP
          for (const [index, record] of invoiceRecords.entries()) {
            try {
              await this.downloadAndAddToZip(zip, record, index);
              processedFiles++;

              // 更新进度
              this.downloadProgress = Math.floor((processedFiles / totalFiles) * 100);

              // 可以在这里添加延迟，避免请求过于频繁
              if (index < totalFiles - 1) {
                await this.delay(100);
              }
            } catch (error) {
              console.error(`下载文件失败 ${record.file_url}:`, error);
              // 继续处理其他文件
            }
          }

          // 生成ZIP文件
          if (processedFiles > 0) {
            await this.generateZipFile(zip);
          } else {
            this.$message.error('没有成功下载任何文件');
            this.downloadDialogVisible = false;
          }

        } catch (error) {
          console.error('打包过程中发生错误:', error);
          this.$message.error('打包失败: ' + error.message);
          this.downloadDialogVisible = false;
        }
      },

// 延迟函数
      delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
      },

// 下载单个文件并添加到ZIP
      async downloadAndAddToZip(zip, record, index) {
        return new Promise( (resolve, reject) => {
          try {
            // 获取文件
            const response =  fetch(record.file_url, {
              method: 'GET',
              mode: 'cors', // 注意跨域问题
              headers: new Headers({
                'Content-Type': 'application/octet-stream',
              }),
            });

            if (!response.ok) {
              throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }

            // 获取文件blob
            const blob =  response.blob();

            // 生成文件名
            const fileName = this.generateFileName(record, blob.type);
            const folderName = '发票文件';

            // 添加到ZIP
            zip.folder(folderName).file(fileName, blob);

            resolve();

          } catch (error) {
            // 如果fetch失败，尝试使用XMLHttpRequest
            console.log('Fetch失败，尝试使用XMLHttpRequest:', error);
            this.downloadWithXHR(zip, record, index)
                    .then(resolve)
                    .catch(reject);
          }
        });
      },
// 使用XMLHttpRequest下载文件
      downloadWithXHR(zip, record, index) {
        console.log(index)
        return new Promise((resolve, reject) => {
          const xhr = new XMLHttpRequest();
          xhr.open('GET', record.file_url, true);
          xhr.responseType = 'blob';

          xhr.onload = function() {
            if (xhr.status === 200) {
              const blob = xhr.response;
              const fileName = this.generateFileName(record, blob.type);
              const folderName = '发票文件';

              zip.folder(folderName).file(fileName, blob);
              resolve();
            } else {
              reject(new Error(`下载失败: HTTP ${xhr.status}`));
            }
          }.bind(this);

          xhr.onerror = function() {
            reject(new Error('网络错误'));
          };

          xhr.ontimeout = function() {
            reject(new Error('请求超时'));
          };

          xhr.timeout = 30000; // 30秒超时

          xhr.send();
        });
      },

// 生成文件名
      generateFileName(record, mimeType) {
        const proxySn = record.proxy ? record.proxy.sn : '未知';
        const month = record.month || '未知月份';
        const amount = record.amount || '0';

        // 根据文件类型确定扩展名
        let extension = '.file';
        if (mimeType) {
          if (mimeType.includes('pdf')) {
            extension = '.pdf';
          } else if (mimeType.includes('jpeg') || mimeType.includes('jpg')) {
            extension = '.jpg';
          } else if (mimeType.includes('png')) {
            extension = '.png';
          } else if (mimeType.includes('gif')) {
            extension = '.gif';
          }
        }

        // 清理文件名中的非法字符
        const cleanFileName = (str) => {
          return str.replace(/[\\/:*?"<>|]/g, '_');
        };

        return cleanFileName(`${proxySn}_${month}_${amount}元${extension}`);
      },

// 生成ZIP文件并下载
      async generateZipFile(zip) {
        try {
          // 生成ZIP文件内容
          const content = await zip.generateAsync({
            type: 'blob',
            compression: 'DEFLATE',
            compressionOptions: {
              level: 6 // 压缩级别 0-9，6是较好的平衡点
            }
          });

          // 保存文件
          const timestamp = moment().format('YYYYMMDD_HHmmss');
          const fileName = `发票批量下载_${timestamp}.zip`;

          saveAs(content, fileName);

          // 更新进度到100%
          this.downloadProgress = 100;

          // 显示成功消息
          setTimeout(() => {
            this.$message.success(`打包完成，共 ${this.downloadInvoiceList.length} 个文件`);
            this.downloadDialogVisible = false;
          }, 1000);

        } catch (error) {
          console.error('生成ZIP文件失败:', error);
          throw error;
        }
      },

// 下载压缩包（如果使用后端打包）
      downloadZipFile() {
        if (this.downloadProgress < 100) {
          this.$message.warning('文件正在打包中，请稍候...');
          return;
        }

        // 如果后端已经打包好，直接下载
        const param = {
          ids: this.downloadInvoiceList.map(item => item.id),
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token')
        };

        // 创建一个隐藏的iframe来下载文件
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = `/api/download/invoices?${this.objToQueryString(param)}`;
        document.body.appendChild(iframe);

        setTimeout(() => {
          document.body.removeChild(iframe);
          this.downloadDialogVisible = false;
        }, 3000);
      },

// 对象转查询字符串
      objToQueryString(obj) {
        const keyValuePairs = [];
        for (const key in obj) {
          keyValuePairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
        }
        return keyValuePairs.join('&');
      },

// 取消下载
      cancelDownload() {
        // 这里可以添加取消下载的逻辑
        this.downloadDialogVisible = false;
        this.downloadProgress = 0;

        // 如果需要中断所有下载请求，可以在这里处理
        this.$message.info('已取消下载');
      },
    }
  }
</script>

<style scoped>
  .demand-list-container {
    padding: 20px;
    background: #f5f7fa;
    min-height: calc(100vh - 60px);
  }

  .breadcrumb-container {
    margin-bottom: 20px;
  }

  .breadcrumb-container .el-breadcrumb {
    font-size: 14px;
  }

  .main-card {
    border-radius: 12px;
    border: none;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }

  /* 搜索区域样式 */
  .search-section {
    background: linear-gradient(135deg, #f8f9fc 0%, #ffffff 100%);
    border-bottom: 1px solid #e6e8f0;
  }

  .search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 20px;
    background: #fafbfc;
    border-bottom: 1px solid #e6e8f0;
  }

  .search-title {
    display: flex;
    align-items: center;
    color: #303133;
    font-weight: 600;
    font-size: 16px;
  }

  .search-title-icon {
    margin-right: 8px;
    color: #409EFF;
    font-size: 18px;
  }

  .search-title-text {
    letter-spacing: 0.5px;
  }

  .toggle-button {
    color: #409EFF;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: 4px;
    transition: all 0.3s;
  }

  .toggle-button:hover {
    background: #ecf5ff;
    transform: translateY(-1px);
  }

  /* 搜索内容区域 */
  .search-content {
    padding: 20px;
  }

  .search-form {
    width: 100%;
  }

  .search-row {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }

  .search-item-group {
    flex: 1;
    min-width: 280px;
  }

  .search-item-group.full-width {
    flex: 2;
    min-width: 500px;
  }

  .search-item {
    margin-bottom: 0 !important;
    width: 100%;
  }

  /* 输入框样式 */
  .search-input {
    width: 100%;
  }

  .search-input >>> .el-input__inner {
    border-radius: 6px;
    border: 1px solid #dcdfe6;
    transition: all 0.3s;
  }

  .search-input >>> .el-input__inner:focus {
    border-color: #409EFF;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }

  .input-prepend {
    color: #606266;
    font-weight: 500;
    padding: 0 12px;
    background: #f5f7fa;
    border-right: 1px solid #dcdfe6;
  }

  /* 选择器样式 */
  .status-select, .type-select {
    width: 100%;
  }

  .status-select >>> .el-input__inner,
  .type-select >>> .el-input__inner {
    border-radius: 6px;
  }

  .status-option {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .status-normal {
    color: #67C23A;
  }

  .status-pending {
    color: #E6A23C;
  }

  .status-rejected {
    color: #F56C6C;
  }

  /* 日期范围选择器 */
  .date-range-container {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .date-range-picker {
    flex: 1;
    min-width: 300px;
  }

  .date-range-picker >>> .el-input__inner {
    border-radius: 6px;
  }

  .quick-date-buttons {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .quick-date-buttons .el-button {
    border-radius: 4px;
    padding: 7px 12px;
  }

  /* 搜索操作按钮 */
  .search-actions {
    display: flex;
    align-items: center;
    gap: 12px;
    padding-top: 16px;
    border-top: 1px dashed #e6e8f0;
    margin-top: 20px;
  }

  .search-btn, .reset-btn {
    border-radius: 6px;
    padding: 9px 20px;
    font-weight: 500;
    transition: all 0.3s;
  }

  .search-btn:hover, .reset-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  }

  .advanced-search-btn {
    color: #909399;
    margin-left: auto;
    transition: color 0.3s;
  }

  .advanced-search-btn:hover {
    color: #409EFF;
  }

  /* 高级搜索区域 */
  .advanced-search-section {
    background: #f8f9fc;
    border-radius: 8px;
    padding: 16px;
    margin-top: 16px;
    border: 1px solid #e6e8f0;
  }

  .advanced-search-title {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #606266;
    font-weight: 600;
    margin-bottom: 16px;
    font-size: 14px;
  }

  .advanced-search-title i {
    color: #409EFF;
  }

  .advanced-search-content {
    padding: 0 8px;
  }

  .amount-separator {
    margin: 0 12px;
    color: #909399;
    font-weight: 500;
  }

  /* 操作按钮区域 */
  .action-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background: #ffffff;
    border-bottom: 1px solid #e6e8f0;
  }

  .action-title {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #303133;
    font-weight: 600;
    font-size: 16px;
  }

  .action-title i {
    color: #409EFF;
  }

  .total-tag {
    margin-left: 12px;
    border-radius: 10px;
  }

  .action-buttons {
    display: flex;
    gap: 12px;
    align-items: center;
  }

  .add-btn, .export-btn {
    border-radius: 6px;
    padding: 9px 16px;
    font-weight: 500;
    transition: all 0.3s;
  }

  .add-btn:hover, .export-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
  }

  .batch-dropdown .el-button {
    border-radius: 6px;
    padding: 9px 16px;
  }

  /* 表格区域 */
  .table-section {
    padding:  20px 0;
  }

  .data-table {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  }

  .data-table >>> .el-table__header {
    border-radius: 8px 8px 0 0;
  }

  .title-text {
    color: #409EFF;
    font-weight: 500;
    transition: color 0.3s;
  }

  .title-text:hover {
    color: #66b1ff;
    cursor: pointer;
  }

  .time-text {
    color: #606266;
    font-size: 12px;
  }

  .amount-text {
    color: #e6a23c;
    font-weight: 600;
    font-size: 14px;
  }

  .auth-time {
    margin-top: 4px;
  }

  /* 发票相关样式 */
  .invoice-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .invoice-preview {
    cursor: pointer;
    transition: all 0.3s;
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: #f5f7fa;
    border: 1px solid #e6e8f0;
  }

  .invoice-preview:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  .invoice-icon {
    font-size: 20px;
  }

  .invoice-thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .no-invoice {
    color: #c0c4cc;
    font-size: 12px;
  }

  /* 操作按钮组 */
  .action-buttons-group {
    display: flex;
    gap: 6px;
    justify-content: center;
  }

  .action-buttons-group .el-button {
    border-radius: 4px;
    padding: 5px 10px;
    font-size: 12px;
  }

  /* 分页区域 */
  .pagination-section {
    padding: 20px;
    display: flex;
    justify-content: center;
    background: #fafbfc;
    border-top: 1px solid #e6e8f0;
  }

  .pagination-section >>> .el-pagination {
    padding: 0;
  }

  /* 审核对话框样式 */
  .audit-dialog >>> .el-dialog__body {
    padding: 10px;
  }

  .audit-info {
    background: #f8f9fa;
    border-radius: 6px;
    padding: 16px;
    border: 1px solid #e9ecef;
  }

  .info-item {
    display: flex;
    margin-bottom: 8px;
    align-items: center;
  }

  .info-item:last-child {
    margin-bottom: 0;
  }

  .info-label {
    color: #606266;
    font-weight: 500;
    min-width: 80px;
    font-size: 13px;
  }

  .info-value {
    color: #303133;
    flex: 1;
  }

  .info-value.amount {
    color: #e6a23c;
    font-weight: 600;
    font-size: 16px;
  }

  .audit-status-group {
    display: flex;
    gap: 20px;
  }

  .audit-radio {
    padding: 12px 20px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    transition: all 0.3s;
  }

  .audit-radio:hover {
    border-color: #409EFF;
  }

  .audit-pass.is-checked {
    background: #f0f9ff;
    border-color: #409EFF;
  }

  .audit-reject.is-checked {
    background: #fef0f0;
    border-color: #f56c6c;
  }

  .audit-radio i {
    margin-right: 6px;
    font-size: 16px;
  }

  /* 审核详情对话框样式 */
  .audit-detail {
    padding: 0 0 10px 0;
  }

  .detail-section {
    margin-bottom: 20px;
  }

  .detail-section:last-child {
    margin-bottom: 0;
  }

  .detail-title {
    color: #303133;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #e6e8f0;
  }

  .detail-content {
    padding: 0 10px;
  }

  .detail-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  .detail-item:last-child {
    margin-bottom: 0;
  }

  .detail-label {
    color: #606266;
    font-weight: 500;
    min-width: 80px;
    font-size: 13px;
  }

  .detail-value {
    color: #303133;
    flex: 1;
  }

  .detail-value.amount {
    color: #e6a23c;
    font-weight: 600;
  }

  .detail-value.remark {
    background: #f8f9fa;
    padding: 8px 12px;
    border-radius: 4px;
    border: 1px solid #e9ecef;
    line-height: 1.5;
  }

  /* 发票预览对话框样式 */
  .invoice-preview-content {
    min-height: 400px;
    display: flex;
    flex-direction: column;
  }

  .pdf-preview {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }

  .pdf-download {
    text-align: center;
    padding: 10px 0;
  }

  .image-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
  }

  .image-tools {
    display: flex;
    gap: 10px;
    justify-content: center;
    padding: 10px 0;
  }

  .image-slot {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 200px;
    color: #909399;
  }

  .image-slot i {
    font-size: 40px;
    margin-bottom: 10px;
  }

  /* 全屏对话框样式 */
  .full-screen-content {
    height: calc(100vh - 60px);
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
  }

  /* 响应式设计 */
  @media (max-width: 1200px) {
    .search-item-group {
      min-width: 250px;
    }

    .search-item-group.full-width {
      min-width: 400px;
    }

    .date-range-picker {
      min-width: 250px;
    }
  }

  @media (max-width: 768px) {
    .demand-list-container {
      padding: 10px;
    }

    .search-row {
      flex-direction: column;
      gap: 16px;
    }

    .search-item-group,
    .search-item-group.full-width {
      min-width: 100%;
    }

    .date-range-container {
      flex-direction: column;
      align-items: stretch;
    }

    .date-range-picker {
      min-width: 100%;
    }

    .quick-date-buttons {
      justify-content: center;
    }

    .action-section {
      flex-direction: column;
      gap: 16px;
      align-items: flex-start;
    }

    .search-actions {
      flex-direction: column;
      align-items: flex-start;
    }

    .advanced-search-btn {
      margin-left: 0;
    }

    .audit-status-group {
      flex-direction: column;
      gap: 10px;
    }

    .action-buttons-group {
      flex-direction: column;
      width: 100%;
    }

    .action-buttons-group .el-button {
      width: 100%;
      margin-bottom: 5px;
    }
  }
</style>

<style>
  /* 全屏对话框全局样式 */
  .full-screen-dialog {
    margin: 0 !important;
    width: 100% !important;
    height: 100%;
  }

  .full-screen-dialog .el-dialog__header {
    background: rgba(0, 0, 0, 0.8);
    color: white;
  }

  .full-screen-dialog .el-dialog__body {
    padding: 0;
    height: calc(100vh - 60px);
  }

  .full-screen-dialog .el-dialog__headerbtn {
    color: white;
  }

  .full-screen-dialog .el-dialog__headerbtn:hover {
    color: #409EFF;
  }

  /* 批量打款对话框样式 */
  .batch-payment-dialog >>> .el-dialog__body {
    padding: 0px;
  }

  .selected-items {
    background: #f8f9fa;
    border-radius: 6px;
    padding: 12px;
    border: 1px solid #e9ecef;
    max-height: 200px;
    overflow-y: auto;
  }

  .selected-count {
    margin-top: 10px;
    padding-top: 10px;
    border-top: 1px dashed #dcdfe6;
    color: #606266;
    font-weight: 500;
  }

  .payment-status-group {
    display: flex;
    gap: 20px;
  }

  .payment-radio {
    padding: 12px 20px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    transition: all 0.3s;
  }

  .payment-radio:hover {
    border-color: #409EFF;
  }

  .payment-success.is-checked {
    background: #f0f9ff;
    border-color: #409EFF;
  }

  .payment-failed.is-checked {
    background: #fef0f0;
    border-color: #f56c6c;
  }

  .payment-voucher-upload {
    width: 100%;
  }

  .payment-voucher-upload >>> .el-upload-list__item {
    transition: all 0.3s;
  }

  /* 下载进度样式 */
  .download-progress {
    text-align: center;
    padding: 20px 0;
  }

  .progress-text {
    color: #606266;
    font-size: 14px;
    margin-bottom: 10px;
  }

  .download-info {
    color: #909399;
    font-size: 13px;
    margin-top: 10px;
  }

  /* 响应式调整 */
  @media (max-width: 768px) {
    .payment-status-group {
      flex-direction: column;
      gap: 10px;
    }

    .selected-items {
      max-height: 150px;
    }
  }


/* 下拉样式（保持不变） */
:deep(.shop-select-dropdown .el-select-dropdown__wrap) {
  max-height: 400px !important;
  overflow-y: auto;
}
:deep(.shop-option-item) {
  height: auto !important;
  padding: 8px 12px !important;
  white-space: normal !important;
  line-height: 1.5 !important;
}
.shop-option {
  line-height: 1;
}
.shop-name {
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
}
.shop-info {
  font-size: 12px;
  color: #909399;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
</style>
